const configuratorRestultsSlider = () => {
    const configuratorWidgetsArray = document.querySelectorAll(".configurator-widget");
    if (configuratorWidgetsArray && configuratorWidgetsArray.length > 0) {
        configuratorWidgetsArray.forEach((configuratorWidget) => {
            const dataResultsConfiguratorList = configuratorWidget.querySelectorAll("[data-result-configurator]");
            dataResultsConfiguratorList.forEach((dataResultConfigurator) => {
                initCarousel("[data-configurator-to-append][data-carousel]", cellAlign.left, true, false, false, null, null);
            });
        });
    }
};
